import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const DropDownAnimation = trigger('DropdownAnimation', [
  state(
    'open',
    style({
      height: '*',
    })
  ),
  state(
    'closed',
    style({
      height: 0,
    })
  ),
  transition('closed => open', [animate('200ms')]),
  transition('open => closed', [animate('200ms')]),
]);
